import type { AccountProvider, MessageDirection, StepChannel } from "./types";

export type InboxIconKind =
  | "mail"
  | "gmail"
  | "outlook"
  | "linkedin"
  | "whatsapp";

/** Select the inbox icon from the actual sending provider when one is known. */
export function resolveInboxIconKind(
  channel: StepChannel | null | undefined,
  provider?: AccountProvider | null,
): InboxIconKind {
  if (channel === "linkedin") return "linkedin";
  if (channel === "whatsapp") return "whatsapp";
  if (channel === "email" && provider === "gmail") return "gmail";
  if (channel === "email" && provider === "outlook") return "outlook";
  return "mail";
}

/** Select the icon for a specific inbox message. */
export function resolveInboxMessageIconKind(
  channel: StepChannel | null | undefined,
  direction: MessageDirection | null | undefined,
  provider?: AccountProvider | null,
): InboxIconKind {
  // An inbound email belongs to the candidate, while `provider` identifies the
  // recruiter's receiving account. Do not mislabel the candidate with it.
  if (channel === "email" && direction === "in") return "mail";
  return resolveInboxIconKind(channel, provider);
}
